<template>
  <div class="container">El Psy Kongroo</div>
</template>

<script>
import store from "@/store/store";
export default {
	name: "ReturnPage",

	created() {
		//console.log("El Psy Kongroo");
		// this.getAll();
		/*
		 * this.getAllContractsUsers();
		 * this.getAllContracts();
		 * this.getAllSocieties();
		 * this.getAllCollaborators();
		 * this.getAllCollaboratorsAvatar();
		 * this.$router.go(-1)
		 */
	},
	methods: {
		/**
		 * Query our API to fetch all the contracts users
		 */
		getAll() {
			this.$store.dispatch("getAllContractsUsers").then(() => {
				//console.log("Gate's open 1");
				this.$store.dispatch("getAllSocietiesIdAndName").then(() => {
					//console.log("Gate's open 2");
					this.$store.dispatch("getAllCollaborators").then(() => {
						//console.log("Gate's open 3");
						this.$store.dispatch("getAllCollaboratorsAvatar").then(() => {
							//console.log("Gate's open 4");
							// this.$store.dispatch("getAllContracts").then(() => {
							// 	//console.log("Gate's open 5");
								this.$router.go(-1);
							// });
						});
					});
				});
			});
		},
		/**
		 * Query our API to fetch all the contracts users
		 */
		getAllContractsUsers() {
			this.$store.dispatch("getAllContractsUsers").then(() => {
				//console.log("Gate's open 1");
			});
		},
		/**
		 * Query our API to fetch all the societies
		 */
		getAllSocieties() {
			this.$store.dispatch("getAllSocietiesIdAndName").then(() => {
				//console.log("Gate's open 2");
			});
		},

		/**
		 * Query our API to fetch all rankwell collaborators
		 */
		getAllCollaborators() {
			this.$store.dispatch("getAllCollaborators").then(() => {
				//console.log("Gate's open 3");
			});
		},

		/**
		 * Query our API to fetch all the rankwell collaborators avatar
		 */
		getAllCollaboratorsAvatar() {
			this.$store.dispatch("getAllCollaboratorsAvatar").then(() => {
				//console.log("Gate's open 4");
			});
		},

		/**
		 * Query API to fetch all the existing contracts
		 * Sorted from the latest to the oldest
		 */
		// getAllContracts() {
		// 	this.$store.dispatch("getAllContracts").then(() => {
		// 		//console.log("Gate's open 5");
		// 	});
		// },
	},
};
</script>

<style scoped>

</style>
